import React from 'react'
import { PhotoSwipe } from 'react-photoswipe';

import { Photo } from "_types/item";
import { resizeUrl } from '_utils/image';

import 'react-photoswipe/lib/photoswipe.css';

interface ImageCarouselProps {
  photos: [Photo];
  isOpen: boolean;
  resize?: boolean;
  onClose: () => void;
  index?: number;
}

export const ImageCarousel: React.FC<ImageCarouselProps> = (props) => {
  const items = props.photos.map(({url, width, height}) => ({
    src: props.resize ? resizeUrl(url, {width: window.innerWidth, height: window.innerHeight}) : url,
    w: width,
    h: height
  }));
  return <PhotoSwipe
    isOpen={props.isOpen}
    items={items}
    options={{
      index: props.index,
      history: false,
      mainClass: "pswp--minimal--dark",
      barsSize: {top: 0, bottom: 0},
      captionEl: false,
      fullscreenEl: false,
      shareEl: false,
      zoomEl: false,
      tapToToggleControls: false,
      closeOnScroll: false,
    }}
    onClose={props.onClose}
  />
}